export default __webpack_public_path__ + "static/media/logo-microgen-white.ce9b2366.png";